<template>
  <div class="product">
    <Header />
    <div class="container main">
      <div class="productOne"
           ref="productOne">
        <productHeader :product="product"
                       :specs="specs"
                       @changeSpecs="changeSpecs"
                       @changeNumber="changeNumber" />
        <!-- <Bonus :product="product" /> -->
        <!-- <oldProduct :assess="assess" /> -->
      </div>
      <!-- <Content @changeContent="changeContent" -->
               <!-- :account="account" /> -->
      <Details :product="product" />

    </div>
    <!-- <div class="footerfixed"
         :class="gobottomheight>350?'footfixed':''">
      <div class=""
           v-if="assess.assessAmount">
        <div class="prouctFooter clearfix"
             ref="product"
             v-if="specs[0]&&specs[0].value">
          <div class="container">
            <div class="footerLeft">
              <span>
                旧机估价 :
                <em>-¥{{assess.assessAmount}}</em>
              </span>
              <span>
                环保补助金:
                <em>-¥{{product.bonus_price*this.number}}</em>
              </span>
              <span v-if="false">
                优惠券 :
                <em>-¥200</em>
              </span>
            </div>
            <p class="tips"></p>
            <div class="footerRight">
              <el-button type="danger"
                         @click="Next()"
                         :loading="loadding">立即换新</el-button>
              <div>
                <span v-if="(parseInt(this.product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)-parseInt(this.product.bonus_price))*this.number-this.assess.assessAmount>0">预计补差价:</span>
                <span v-else>「0元换」额外赚:</span>
                <span>
                  <em>¥</em>
                  {{Math.abs((parseInt(this.product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)-parseInt(this.product.bonus_price))*this.number-this.assess.assessAmount)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="prouctFooter clearfix"
             v-if="!user.dialogVisibleValue">
          <div class="container">
            <div class="footerLeft">
              <p class="tips"
                 style="width:900px">点击添加旧机 享受超额优惠</p>
            </div>
            <div class="footerRight">
              <el-button type="danger"
                         @click="changeVisibleValue">立即添加</el-button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <Footer />
  </div>
</template>

<script>
import { encrypt, setCookie } from "@/utils";

import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
import productHeader from "@/components/PC/Product/Header.vue";
import oldProduct from "@/components/PC/Product/oldProduct.vue";
import Details from "@/components/PC/Product/Details.vue";
import Bonus from "@/components/PC/Product/Bonus.vue";
import Content from "@/components/PC/Product/Content.vue";

export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      specs: [
        // {value:1,price:0},
        // {value:2,price:0},
      ],
      amount: 0,
      form: {
        name: "",
        phone: "",
        city: [],
        address: ""
      },
      number: 1,
      count: "",
      loadding: false,
      dialogVisibleValue: false,
      isfooterbottom: false,
      gobottomheight: 0
    };
  },
  components: {
    Header,
    Footer,
    productHeader,
    oldProduct,
    Content,
    Bonus,
    Details
  },
  mounted: function () {
    window.scroll(0, 0);
    let _this = this;
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      _this.gobottomheight = scrollHeight - (scrollTop + windowHeight);
    }
  },
  computed: {
    product () {
      return this.$store.state.product.product;
    },
    assess () {
      return this.$store.state.assess.assess;
    },
    account () {
      return this.$store.state.account.user;
    },
    user () {
      return this.$store.state.user;
    },
  },
  methods: {
    fetchProductData (params) {
      this.$store.dispatch("product/fetchProductData", { params }).then(() => {
        for (let i = 0; i < this.product.attr.length; i++) {
          for (let j = 0; j < this.product.attr[i]["attr_value"].length; j++) {
            if (j == 0) {
              let data = {
                value: this.product.attr[i]["attr_value"][0]["attr_value_id"],
                price: this.product.attr[i]["attr_value"][0]["attr_price"],
                name: this.product.attr[i]["attr_value"][0]["attr_value_name"]
              };
              this.specs.push(data);
            }
          }
        }
        this.amount = this.product.price;
      });
    },
    changeSpecs (data) {
      this.specs = data;
    },
    changeNumber (data) {
      this.number = data;
    },
    changeVisibleValue (value) {
      this.$store.commit('user/setVisibleValue');
    },
    changeContent (value) {
      this.form = value;
    },
    handleScroll () {
      var sortMenu = this.$refs.product.scrollTop;
    },
    Next () {
      let attrids = "";
      let attrs = "";
      if (!this.assess.goodsId) {
        this.$message({
          message: "必须添加旧机才能换新.",
          type: "error"
        });
        return false;
      }
      let amount = parseInt(this.product.price) - parseInt(this.product.bonus_price);
      for (let i = 0; i < this.specs.length; i++) {
        attrids += this.specs[i].value + ",";
        attrs += this.specs[i].name + ",";
        amount += parseInt(this.specs[i].price);
      }
      if (!this.form.name) {
        window.scrollTo(0, this.$refs.productOne.offsetHeight)
        this.$message({
          message: "请输入姓名.",
          type: "error"
        });
        return false;
      }
      if (!this.account.userid) {
        this.$message({
          message: "请先获取验证码登录.",
          type: "error"
        });
        return false;
      }
      if (!this.form.address) {
        this.$message({
          message: "请输入地址.",
          type: "error"
        });
        return false;
      }
      this.loadding = !this.loadding;
      let params = {
        goodsid: this.product.id,
        number: this.number,
        name: this.form.name,
        mobile: this.account.mobile,
        userid: this.account.userid,
        address: this.form.city.join(",") + " " + this.form.address,
        referer: "PC",
        source: 1,
        bonus: 0,
        bonusid: 0,
        amount: amount * this.number,
        attrids: attrids,
        attrs: attrs,
        oldattrids: this.assess.assessAttrId,
        oldattrs: this.assess.assessAttr,
        oldgoodsid: this.assess.goodsId,
        oldamount: this.assess.assessAmount
      };
      this.$store.dispatch("order/fetchCreateOrder", { params }).then(() => {
        // console.log(this.$store.state.order.neworder);
        let neworder = JSON.stringify(this.$store.state.order.neworder);
        setCookie("neworder", encrypt(neworder), true);
        this.$router.push({ path: "/checkout" });
      });
    }
  },
  created () {
    let id = this.$route.params.id;
    let params = {
      id: id
    };
    this.fetchProductData(params);

  },
  watch: {}
};
</script>
<style>
.product {
  background: #efefef;
}
.product .main {
  padding-bottom: 10px;
}
.product .footer {
  margin-top: 0 !important;
}
.productBonus {
  display: flex;
  padding: 20px 20px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 10px 0;
  border-radius: 4px;
  position: relative;
}
.productBonus p:nth-child(1) span {
  color: #f9415d;
}
.bonusChecked {
  position: absolute;
  right: 20px;
  top: 20px;
}
.prouctFooter {
  width: 100%;
  z-index: 0;

  z-index: 9999;
}
.footfixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.prouctFooter .container {
  height: 60px;
  padding: 0 20px;
  background: #fff;
  width: 1226px;
  margin: 0 auto;
  border-top: solid #efefef 1px;
  /* border:solid #efefef 1px; */
}
.prouctFooter .tips {
  width: 400px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: #f9415d;
}
.footerLeft {
  width: 400px;
  line-height: 60px;
  float: left;
}
.footerLeft span {
  color: #888;
  margin-right: 50px;
}
.footerLeft em {
  color: #000;
  font-style: normal;
  margin-left: 5px;
}
.footerRight {
  width: 526px;
  text-align: right;
  float: right;
}
.footerRight div {
  float: right;
  margin-right: 50px;
  line-height: 60px;
}
.footerRight div span:nth-child(2) {
  color: #f9415d;
  font-size: 24px;
  margin-left: 5px;
}
.footerRight div em {
  font-style: normal;
  font-size: 14px;
}
.footerRight button {
  float: right;
  display: inline-block;
  border: 0;
  color: #fff;
  height: 60px;
  padding: 0 50px;
  margin-right: -20px;
  border-radius: 0;
  outline: none;
  border-color: transparent;
  box-shadow: none;
  background: #f9415d;
}
</style>
